import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import {
  BillingReadinessResponse,
  BillingReadinessWindow,
} from '@chiroup/core/types/BillingReadiness.type';

const billingReadinessService = () => {
  const list = async (window: BillingReadinessWindow): Promise<BillingReadinessResponse> => {
    return ChiroUpAPI.get('api', '/billing-readiness', { queryParams: { window } });
  };

  return { list };
};

export default billingReadinessService();
